var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormGroup",
        {
          attrs: {
            label: "Bitte wähle den nächsten Schritt aus",
            "label-classes": ["font-weight-bold"]
          }
        },
        [
          _c("RadioGroup", {
            attrs: { options: _vm.followUpOptions, stacked: "" },
            model: {
              value: _vm.followUp,
              callback: function($$v) {
                _vm.followUp = $$v
              },
              expression: "followUp"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.followUpAppointment
        ? _c("MakeAppointment", {
            staticClass: "mt-4",
            attrs: {
              message: _vm.message,
              action: _vm.actionFollowUpAppointment
            },
            on: {
              success: function($event) {
                return _vm.$emit("processed")
              }
            },
            model: {
              value: _vm.makeAppointmentData,
              callback: function($$v) {
                _vm.makeAppointmentData = $$v
              },
              expression: "makeAppointmentData"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.followUpInterested
        ? _c("CustomerInterested", {
            staticClass: "mt-4",
            attrs: { message: _vm.message },
            on: {
              processed: function($event) {
                return _vm.$emit("processed")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.followUpSendoff
        ? _c("CustomerSendOff", {
            staticClass: "mt-3",
            attrs: {
              "disclosed-data": _vm.message.disclosedData,
              pseudonym: _vm.message.pseudonym,
              "with-applicant-name": false
            },
            model: {
              value: _vm.sendOffData,
              callback: function($$v) {
                _vm.sendOffData = $$v
              },
              expression: "sendOffData"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.followUpSendoff
        ? _c(
            "div",
            { staticClass: "mt-3 text-right" },
            [
              _c("Button", {
                attrs: {
                  text: "Senden",
                  icon: "checkmark",
                  disabled: !_vm.dataValid || _vm.sendingRequest,
                  loading: _vm.sendingRequest
                },
                on: { click: _vm.submit }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }